export default __webpack_public_path__ + "static/media/Deelnemers oldtimerrit.9bcc753c.jpg";